import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import RouteMap from '../components/RouteMap';

import ResultMessage from '../images/icon_otsu.svg';
import CAL from '../images/icon_cal.svg';
import TIME from '../images/icon_time.svg';

export default function Result() {
	// TODO : カロリーと走行時間を算出して置き換える
	const location = useLocation();

	const calorie = location.state.calorie || 0;
	const time = location.state.timer || 0;

	const hour = Math.floor(time/3600);
	const minute = Math.floor((time-hour*3600)/60)
	const second = time-hour*3600-minute*60
	const time_s = ((hour<10)?"0"+hour:hour)+":"+((minute<10)?"0"+minute:minute)+":"+((second<10)?"0"+second:second);

	return (
		<div className="main">
			<img className="result_title" src={ResultMessage} alt="お疲れさまでした！"/>
			<div className="result_smalls">
			  <div className="result_small">
					消費カロリー
					<img src={CAL} alt="🔥"/>
					<span>{calorie.toFixed(1)}kcal</span>
			  </div>
			  <div className="result_small">
					走行タイム
					<img src={TIME} alt="⏰"/>
					<span>{time_s}</span>
			  </div>
			</div>
			<RouteMap routes={location.state.positions}/>
			<Link className="button" to='/'>ホーム画面に戻る</Link>
		</div>
	)
}
